/**
 * Resolve display/sort label for a city row from the API or legacy shapes.
 */
export function getCityDisplayName(city) {
  if (city == null) return '';
  if (typeof city === 'string') return city.trim();
  const raw =
    city.name ??
    city.Name ??
    city.cityName ??
    city.city ??
    city.label ??
    city.title ??
    '';
  return String(raw).trim();
}

/**
 * Returns a new array of cities sorted A–Z by display name.
 */
export function sortCitiesByName(cities) {
  if (!Array.isArray(cities)) return [];
  return [...cities].sort((a, b) =>
    getCityDisplayName(a).localeCompare(getCityDisplayName(b), 'en', {
      sensitivity: 'base',
      numeric: true,
    }),
  );
}
